import React from 'react';
import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';
import OHIF from '@ohif/core';
import { Component } from 'react';
import { servicesManager } from '../../App.js';
import MarkRectangleRoi from '@ohif/viewer/src/appExtensions/tools/MarkRectangleRoiTool';

import './AnalysisReport.css';

import {
  getList,
  // getAnalysisResultList,
  getAnalysisResultLis2t,
  confirmAiResult,
  saveAiCheck,
  saveAiCheckedItem,
} from './makeData';
import { MainList, SubList } from './index.js';
import guid from '../../../../core/src/utils/guid.js';

const { studyMetadataManager } = OHIF.utils;
// const {
//   setViewportSpecificData,
//   setActiveViewportSpecificData,
// } = OHIF.redux.actions;

class AnalysisReport extends Component {
  constructor(props) {
    super(props);
    //textarea变化监听
    // this.areaRef = useRef < HTMLTextAreaElement > null;
    //绑定函数
    this.handleTextareaChange = this.handleTextareaChange.bind(this);
    this.save = this.save.bind(this);
    //状态值
    this.state = {
      id: '',
      aiCheckId: '',
      aiInfoId: '',
      originTextareaValue: [],
      textareaValue: '',
      userInput: [],
      displaySets: [],
      checked: false,

      data: [],
      mainListData: false,
      subListData: false,
      data2: [],
      orderData: [],
      filter: [],
      detailIds: [],
      ids: {},
      expandeds: {},
      idx: 0,
      // studyMetadata: '',
    };
    cornerstoneTools.addTool(MarkRectangleRoi);
    cornerstoneTools.setToolEnabled('MarkRectangleRoi', {
      mouseButtonMask: 1,
    });
  }

  componentDidUpdate() {
    const element = document.querySelector('.viewport-element');
    const tool = cornerstoneTools.getToolForElement(
      element,
      'MarkRectangleRoi'
    );
    if (tool) {
      tool._configuration.drawHandlesOnHover = true;
    }
  }

  // react 生命周期 axios 请求数据
  async componentDidMount() {
    const { aiCheckId } = this.props;
    let data = [],
      id,
      newAiCheckId = '',
      aiInfoId = '';
    getList({ aiCheckId }).then(res => {
      if (res.status === 'success') {
        if (res.list && res.list.length > 0) {
          data = res.list.map((item, index) => {
            item.index = index + 1;
            item.statusLabel = item.result.status;
            item.resultInfo = item.result.resultInfo;
            return item;
          });
          id = res.list[0].result.id;
          newAiCheckId = res.list[0].result.aiCheckId;
          aiInfoId = res.list[0].result.aiInfoId;

          this.state.textareaValue = res.data.report;
          this.state.originTextareaValue = res.data.report.split('\n');
          this.setState({
            id: id,
            aiCheckId: newAiCheckId,
            aiInfoId: aiInfoId,
          });

          this.getAnalysisResultList({
            aiCheckId: newAiCheckId,
            aiInfoId: aiInfoId,
          });
        }
        this.setState({
          // ids: 0,
          mainListData: true,
          data: data,
        });
      } else {
        console.log(res);
      }
    });
  }

  async confirmAiResult(payload, idx) {
    confirmAiResult(payload).then(res => {
      if (res.status === 'success') {
        getList({ aiCheckId: this.props.aiCheckId }).then(res2 => {
          if (res2.status === 'success') {
            if (res2.list && res2.list.length > 0) {
              let list = res2.list.map((item, index) => {
                item.index = index + 1;
                item.statusLabel = item.result.status;
                item.resultInfo = item.result.resultInfo;
                return item;
              });
              this.setState({
                data: list,
              });
              this.getAnalysisResultList({
                aiCheckId: payload.aiCheckId,
                aiInfoId: payload.aiInfoId,
              });
            }
          } else {
            console.log(res);
          }
        });
      } else {
        console.log(res);
      }
    });
  }

  save() {
    let payload = {
      id: this.state.aiCheckId,
      report: this.state.textareaValue,
    };
    this.saveAiCheck(payload);

    let payload2 = {
      id: this.state.id,
      aiCheckId: this.state.aiCheckId,
      aiInfoId: this.state.aiInfoId,
      status: '30',
      // idx: this.state.idx
    };
    this.confirmAiResult(payload2);
    let payload3 = {
      aiInfoResultId: this.state.id,
      selectedDetailIds: this.state.detailIds,
      selected: '1',
    };
    this.saveAiCheckedItem(payload3);
  }

  async saveAiCheck(payload) {
    const { UINotificationService } = servicesManager.services;
    saveAiCheck(payload).then(res => {
      if (res.status === 'success') {
        const message = '';
        UINotificationService.show({
          title: '保存成功',
          message,
          type: 'info',
        });
      } else {
        console.log(res);
      }
    });
  }

  async saveAiCheckedItem(payload) {
    saveAiCheckedItem(payload).then(res => {
      if (res.status === 'success') {
        console.log('状态保存成功');
      } else {
        console.log(res);
      }
    });
  }

  getAnalysisResultList(payload) {
    let analysisResult = [];
    let orderData = [];
    let indexs = {};
    let ids = [];
    getAnalysisResultLis2t(payload).then(res2 => {
      if (res2.status === 'success') {
        //清空画布标注
        const element = document.querySelector('.viewport-element');
        // cornerstoneTools.clearToolState(element, 'MarkRectangleRoi');
        const {
          toolState,
          clearImageIdToolState,
        } = cornerstoneTools.globalImageIdSpecificToolStateManager;
        Object.keys(toolState).forEach(imageId => {
          // 使用该清除函数可不调用手动更新视图函数
          clearImageIdToolState(imageId);
        });

        // const toolState = cornerstoneTools.globalImageIdSpecificToolStateManager.saveToolState();
        // for (let i in toolState) {
        //   toolState[i].MarkRectangleRoi.data = [];
        // }
        if (element) {
          cornerstone.updateImage(element);
        }

        let filters = [];
        if (res2.data && res2.data.length) {
          res2.data.map((item, index) => {
            let obj = {
              detailId: item.detailId,
              index: index + 1,
              conslusion: item.conslusion,
              location: JSON.parse(item.location),
              _id: guid(),
              selected: item.selected == '1' ? true : false,
              subRows: [],
            };
            if (item.selected == '1') {
              let original = {
                location: JSON.parse(item.location),
                _id: obj._id,
              };
              this.addTag({ original: original });
              indexs[index] = true;
              ids.push(item.detailId);
            }
            let subObj1 = {};
            let subObj2 = {};
            item.result.map((i, idx) => {
              if (index === 0) {
                orderData.push(i.key);
              }
              if (idx < 3) {
                obj['name' + idx] = i.value;
              } else if (idx < 6) {
                subObj1['name' + (idx - 3)] = i.value;
              } else {
                subObj2['name' + (idx - 6)] = i.value;
              }
            });
            if (Object.keys(subObj1).length > 0) {
              obj.subRows.push(subObj1);
            }
            if (Object.keys(subObj2).length > 0) {
              obj.subRows.push(subObj2);
            }
            analysisResult.push(obj);
          });
          filters = res2.data[0].result.map((i, idx) => {
            return {
              value: i.key,
              label: i.key,
              pid: 0,
              rid: idx + 1,
              keyword: [],
            };
          });
        } else {
          analysisResult = [];
        }
        let isAll = false;
        if (ids.length && ids.length === analysisResult.length) {
          isAll = true;
        }

        this.setState({
          ids: indexs,
          detailIds: ids,
          checked: isAll,
          filter: filters,
          data2: analysisResult,
          orderData: orderData,
          subListData: true,
          aiInfoId: payload.aiInfoId,
        });
      } else {
        console.log(res2);
      }
    });
  }

  //设置textareaValue
  handleTextareaChange(e) {
    this.setState({
      textareaValue: e.target.value,
    });
  }

  handleBlur = e => {
    /**
     * Only save to database when losing focus through clicking
     * outside of the text area, not for every blur event.
     */
    console.log(event.target);
    // console.log(this.areaRef);
    // if (e && e.target.value && e.target.value.trim().length) {
    //     this.state.userInput.push(e.target.value);
    //     this.state.originTextareaValue = e.target.value.split('\n');
    // } else {
    //     this.state.originTextareaValue = [];
    // }
    // if (this.areaRef.current && !this.areaRef.current.contains(event.target)) {
    //     saveToDatabase();
    // }
  };

  clickTextareaChange = (d, ds) => {
    if (d === true) {
      if (ds && ds.length > 0) {
        let dsArr = ds.filter(
          item => this.state.detailIds.indexOf(item.detailId) == -1
        );
        this.addAllTag(dsArr);
      }
      let string = '';
      let arr = [];
      ds.map(item => {
        string += item.conslusion + '\n';
        arr.push(item.detailId);
      });
      this.setState({
        checked: true,
        textareaValue: string,
        detailIds: arr,
      });
    } else if (d === false) {
      this.removeAllTag();
      this.setState({
        checked: false,
        textareaValue: '',
        detailIds: [],
      });
    } else {
      if (d.isSelected) {
        this.removeTag(d);
        this.remove(d.original.detailId, this.state.detailIds);
        this.remove(d.original.location.report, this.state.originTextareaValue);
      } else {
        this.rowSelected(d);
        this.addTag(d);
        this.state.detailIds.push(d.original.detailId);
        this.state.originTextareaValue.push(d.original.location.report);
      }
      if (
        this.state.detailIds &&
        this.state.data2.length === this.state.detailIds.length
      ) {
        this.state.checked = true;
      } else {
        this.state.checked = false;
      }

      this.setState({
        textareaValue: this.state.originTextareaValue.join('\n'),
      });
    }
  };

  addTag(d) {
    const studyMetadata = studyMetadataManager.all();
    if (studyMetadata && studyMetadata.length > 0) {
      let index = d.original.location.range_z;
      let range_x = d.original.location.range_x;
      let range_y = d.original.location.range_y;
      if (
        studyMetadata[0]._data &&
        studyMetadata[0]._data.displaySets &&
        studyMetadata[0]._data.displaySets.length > 0
      ) {
        let displaySets = studyMetadata[0]._data.displaySets.filter(
          i => i.SeriesInstanceUID == d.original.location.seriesInstanceUid
        );
        const toolState = cornerstoneTools.globalImageIdSpecificToolStateManager.saveToolState();
        if (displaySets && displaySets.length > 0) {
          let displaySet = displaySets[0];
          // let SliceThickness =
          //   displaySet.images[0]._instance.metadata.SliceThickness;
          //新
          // let idx = displaySet.numImageFrames - parseInt((index[0] + index[1]) / 2);
          let idx = parseInt((index[0] + index[1]) / 2) - 1;
          displaySet.SOPInstanceUID = displaySet.images[idx].SOPInstanceUID;
          let frameIndex = displaySet.frameIndex ? displaySet.frameIndex : 0;
          if (index[0] === index[1]) {
            let itemData = displaySet.images[idx];
            const imageId = 'dicomweb:' + itemData._data.wadouri;
            if (!toolState[imageId]) {
              toolState[imageId] = {};
            }
            const currentToolState = toolState[imageId]['MarkRectangleRoi'];
            const toolData = currentToolState && currentToolState.data;

            if (toolData && toolData.length) {
              console.log('未知');
            } else {
              toolState[imageId]['MarkRectangleRoi'] = {
                data: [],
              };
            }
            toolState[imageId]['MarkRectangleRoi'].data.map(
              item => (item.active = false)
            );
            let measurement = {
              visible: true,
              active: true,
              invalidated: true,
              isMeasurements: true,
              handles: {
                start: {
                  color: 'blue',
                  activeColor: 'red',
                  x: range_x[0],
                  y: range_y[0],
                  highlight: true,
                  active: false,
                },
                end: {
                  x: range_x[1],
                  y: range_y[1],
                  highlight: true,
                  active: false,
                  moving: false,
                },
                initialRotation: 0,
                textBox: {
                  active: false,
                  hasMoved: false,
                  movesIndependently: false,
                  drawnIndependently: true,
                  allowedOutsideImage: true,
                  hasBoundingBox: true,
                  x: 277.4,
                  y: 193,
                  boundingBox: {
                    width: 280.53,
                    height: 45,
                    left: 601,
                    top: 299,
                  },
                },
              },
              uuid: displaySet.uid,
              _id: d.original._id,
              StudyInstanceUID: displaySet.StudyInstanceUID,
              SeriesInstanceUID: displaySet.SeriesInstanceUID,
              SOPInstanceUID: displaySet.images[frameIndex].SOPInstanceUID,
              toolType: 'MarkRectangleRoi',
              cachedStats: {
                area: Number(d.original.location.area),
                count: 13158,
                mean: 48.58,
                variance: 181,
                stdDev: 134,
                min: -1086,
                max: 933,
              },
              unit: 'HU',
            };
            toolState[imageId]['MarkRectangleRoi'].data.push(measurement);
          } else {
            // let idxstart = displaySet.numImageFrames - parseInt(index[0]);
            // let idxend = displaySet.numImageFrames - parseInt(index[1]);
            let idxstart = parseInt(index[1] - 1);
            let idxend = parseInt(index[0] - 1);
            displaySet.images.map((item, idx) => {
              if (idx >= idxend && idx <= idxstart) {
                const imageId = 'dicomweb:' + item._data.wadouri;
                if (!toolState[imageId]) {
                  toolState[imageId] = {};
                }
                const currentToolState = toolState[imageId]['MarkRectangleRoi'];
                const toolData = currentToolState && currentToolState.data;

                if (toolData && toolData.length) {
                  console.log('未知');
                } else {
                  toolState[imageId]['MarkRectangleRoi'] = {
                    data: [],
                  };
                }
                toolState[imageId]['MarkRectangleRoi'].data.map(
                  item => (item.active = false)
                );
                let measurement = {
                  visible: true,
                  active: true,
                  invalidated: false,
                  isMeasurements: true,
                  handles: {
                    start: {
                      color: 'blue',
                      activeColor: 'red',
                      x: range_x[0],
                      y: range_y[0],
                      highlight: true,
                      active: false,
                    },
                    end: {
                      x: range_x[1],
                      y: range_y[1],
                      highlight: true,
                      active: false,
                      moving: false,
                    },
                    initialRotation: 0,
                    textBox: {
                      active: false,
                      hasMoved: false,
                      movesIndependently: false,
                      drawnIndependently: true,
                      allowedOutsideImage: true,
                      hasBoundingBox: true,
                      x: 277.4,
                      y: 193,
                      boundingBox: {
                        width: 280.53,
                        height: 45,
                        left: 601,
                        top: 299,
                      },
                    },
                  },
                  uuid: displaySet.uid,
                  _id: d.original._id,
                  StudyInstanceUID: displaySet.StudyInstanceUID,
                  SeriesInstanceUID: displaySet.SeriesInstanceUID,
                  SOPInstanceUID: displaySet.images[frameIndex].SOPInstanceUID,
                  toolType: 'MarkRectangleRoi',
                  cachedStats: {
                    area: Number(d.original.location.area),
                    count: 13158,
                    mean: 48.58,
                    variance: 181,
                    stdDev: 134,
                    min: -1086,
                    max: 933,
                  },
                  unit: 'HU',
                };
                toolState[imageId]['MarkRectangleRoi'].data.push(measurement);
              }
            });
          }

          cornerstoneTools.globalImageIdSpecificToolStateManager.restoreToolState(
            toolState
          );
          cornerstone.getEnabledElements().forEach(enabledElement => {
            if (enabledElement.image) {
              cornerstone.updateImage(enabledElement.element);
            }
          });
        } else {
          console.log('数据错误');
        }
      } else {
        const { UINotificationService } = servicesManager.services;

        UINotificationService.show({
          title: '提示',
          message: '数据加载中，请等待数据加载完成后再试',
          type: 'info',
        });
      }
    }
  }

  addAllTag(ds) {
    const studyMetadata = studyMetadataManager.all();
    if (studyMetadata && studyMetadata.length > 0) {
      for (let i = 0; i < ds.length; i++) {
        let index = ds[i].location.range_z;
        let range_x = ds[i].location.range_x;
        let range_y = ds[i].location.range_y;
        if (
          studyMetadata[0]._data &&
          studyMetadata[0]._data.displaySets &&
          studyMetadata[0]._data.displaySets.length > 0
        ) {
          let displaySets = studyMetadata[0]._data.displaySets.filter(
            j => j.SeriesInstanceUID == ds[i].location.seriesInstanceUid
          );
          const toolState = cornerstoneTools.globalImageIdSpecificToolStateManager.saveToolState();
          if (displaySets && displaySets.length > 0) {
            let displaySet = displaySets[0];
            //新
            // let idx = displaySet.numImageFrames - parseInt((index[0] + index[1]) / 2);
            let idx = parseInt((index[0] + index[1]) / 2) - 1;
            displaySet.SOPInstanceUID = displaySet.images[idx].SOPInstanceUID;
            let frameIndex = displaySet.frameIndex ? displaySet.frameIndex : 0;
            if (index[0] === index[1]) {
              let itemData = displaySet.images[idx];
              const imageId = 'dicomweb:' + itemData._data.wadouri;
              if (!toolState[imageId]) {
                toolState[imageId] = {};
              }
              const currentToolState = toolState[imageId]['MarkRectangleRoi'];
              const toolData = currentToolState && currentToolState.data;

              if (toolData && toolData.length) {
                console.log('未知');
              } else {
                toolState[imageId]['MarkRectangleRoi'] = {
                  data: [],
                };
              }
              let measurement = {
                visible: true,
                active: false,
                invalidated: false,
                isMeasurements: true,
                handles: {
                  start: {
                    x: range_x[0],
                    y: range_y[0],
                    highlight: true,
                    active: false,
                  },
                  end: {
                    x: range_x[1],
                    y: range_y[1],
                    highlight: true,
                    active: false,
                    moving: false,
                  },
                  initialRotation: 0,
                  textBox: {
                    active: false,
                    hasMoved: false,
                    movesIndependently: false,
                    drawnIndependently: true,
                    allowedOutsideImage: true,
                    hasBoundingBox: true,
                    x: 277.4,
                    y: 193,
                    boundingBox: {
                      width: 280.53,
                      height: 45,
                      left: 601,
                      top: 299,
                    },
                  },
                },
                uuid: displaySet.uid,
                _id: ds[i]._id,
                StudyInstanceUID: displaySet.StudyInstanceUID,
                SeriesInstanceUID: displaySet.SeriesInstanceUID,
                SOPInstanceUID: displaySet.images[frameIndex].SOPInstanceUID,
                toolType: 'MarkRectangleRoi',
                cachedStats: {
                  area: Number(ds[i].location.area),
                  count: 13158,
                  mean: 48.58,
                  variance: 181,
                  stdDev: 134,
                  min: -1086,
                  max: 933,
                },
                unit: 'HU',
              };
              toolState[imageId]['MarkRectangleRoi'].data.push(measurement);
            } else {
              // let idxstart = displaySet.numImageFrames - parseInt(index[0]);
              // let idxend = displaySet.numImageFrames - parseInt(index[1]);
              let idxstart = parseInt(index[1] - 1);
              let idxend = parseInt(index[0] - 1);
              displaySet.images.map((item, idx) => {
                if (idx >= idxend && idx <= idxstart) {
                  const imageId = 'dicomweb:' + item._data.wadouri;
                  if (!toolState[imageId]) {
                    toolState[imageId] = {};
                  }
                  const currentToolState =
                    toolState[imageId]['MarkRectangleRoi'];
                  const toolData = currentToolState && currentToolState.data;

                  if (toolData && toolData.length) {
                    console.log('未知');
                  } else {
                    toolState[imageId]['MarkRectangleRoi'] = {
                      data: [],
                    };
                  }
                  let measurement = {
                    visible: true,
                    active: false,
                    invalidated: false,
                    isMeasurements: true,
                    handles: {
                      start: {
                        x: range_x[0],
                        y: range_y[0],
                        highlight: true,
                        active: false,
                      },
                      end: {
                        x: range_x[1],
                        y: range_y[1],
                        highlight: true,
                        active: false,
                        moving: false,
                      },
                      initialRotation: 0,
                      textBox: {
                        active: false,
                        hasMoved: false,
                        movesIndependently: false,
                        drawnIndependently: true,
                        allowedOutsideImage: true,
                        hasBoundingBox: true,
                        x: 277.4,
                        y: 193,
                        boundingBox: {
                          width: 280.53,
                          height: 45,
                          left: 601,
                          top: 299,
                        },
                      },
                    },
                    uuid: displaySet.uid,
                    _id: ds[i]._id,
                    StudyInstanceUID: displaySet.StudyInstanceUID,
                    SeriesInstanceUID: displaySet.SeriesInstanceUID,
                    SOPInstanceUID:
                      displaySet.images[frameIndex].SOPInstanceUID,
                    toolType: 'MarkRectangleRoi',
                    cachedStats: {
                      area: Number(ds[i].location.area),
                      count: 13158,
                      mean: 48.58,
                      variance: 181,
                      stdDev: 134,
                      min: -1086,
                      max: 933,
                    },
                    unit: 'HU',
                  };
                  toolState[imageId]['MarkRectangleRoi'].data.push(measurement);
                }
              });
            }

            cornerstoneTools.globalImageIdSpecificToolStateManager.restoreToolState(
              toolState
            );
            cornerstone.getEnabledElements().forEach(enabledElement => {
              if (enabledElement.image) {
                cornerstone.updateImage(enabledElement.element);
              }
            });
          } else {
            console.log('数据错误');
          }
        } else {
          const { UINotificationService } = servicesManager.services;

          UINotificationService.show({
            title: '提示',
            message: '数据加载中，请等待数据加载完成后再试',
            type: 'info',
          });
        }
      }
    }
  }

  removeTag(d) {
    const studyMetadata = studyMetadataManager.all();
    if (studyMetadata && studyMetadata.length > 0) {
      let toolType = 'MarkRectangleRoi';
      let index = d.original.location.range_z;
      if (
        studyMetadata[0]._data &&
        studyMetadata[0]._data.displaySets &&
        studyMetadata[0]._data.displaySets.length > 0
      ) {
        let displaySets = studyMetadata[0]._data.displaySets.filter(
          i => i.SeriesInstanceUID == d.original.location.seriesInstanceUid
        );
        const toolState = cornerstoneTools.globalImageIdSpecificToolStateManager.saveToolState();
        let displaySet = displaySets[0];
        // let SliceThickness =
        //   displaySet.images[0]._instance.metadata.SliceThickness;
        //新
        // let idx = displaySet.numImageFrames - parseInt((index[0] + index[1]) / 2);
        let idx = parseInt((index[0] + index[1]) / 2) - 1;
        displaySet.SOPInstanceUID = displaySet.images[idx].SOPInstanceUID;
        // let frameIndex = displaySet.frameIndex ? displaySet.frameIndex : 0;
        if (index[0] === index[1]) {
          let itemData = displaySet.images[idx];
          const imageId = 'dicomweb:' + itemData._data.wadouri;
          if (imageId && toolState[imageId]) {
            const toolData = toolState[imageId][toolType];
            const measurementEntries = toolData && toolData.data;
            const measurementEntry = measurementEntries.find(
              mEntry => mEntry._id === d.original._id
            );
            if (measurementEntry) {
              const index = measurementEntries.indexOf(measurementEntry);
              measurementEntries.splice(index, 1);
            }
          }
        } else {
          // let idxstart = displaySet.numImageFrames - parseInt(index[0]);
          // let idxend = displaySet.numImageFrames - parseInt(index[1]);
          let idxstart = parseInt(index[1] - 1);
          let idxend = parseInt(index[0] - 1);
          displaySet.images.map((item, idx) => {
            if (idx >= idxend && idx <= idxstart) {
              const imageId = 'dicomweb:' + item._data.wadouri;
              if (imageId && toolState[imageId]) {
                const toolData = toolState[imageId][toolType];
                const measurementEntries = toolData && toolData.data;
                const measurementEntry = measurementEntries.find(
                  mEntry => mEntry._id === d.original._id
                );
                if (measurementEntry) {
                  const index = measurementEntries.indexOf(measurementEntry);
                  measurementEntries.splice(index, 1);
                }
              }
            }
          });
        }
        cornerstoneTools.globalImageIdSpecificToolStateManager.restoreToolState(
          toolState
        );

        cornerstone.getEnabledElements().forEach(enabledElement => {
          if (enabledElement.image) {
            cornerstone.updateImage(enabledElement.element);
          }
        });
      } else {
        const { UINotificationService } = servicesManager.services;

        UINotificationService.show({
          title: '提示',
          message: '数据加载中，请等待数据加载完成后再试',
          type: 'info',
        });
      }
    }
  }

  removeAllTag() {
    const element = document.querySelector('.viewport-element');
    const toolState = cornerstoneTools.globalImageIdSpecificToolStateManager.saveToolState();
    for (let i in toolState) {
      toolState[i].MarkRectangleRoi.data = [];
    }

    // cornerstoneTools.removeTool('MarkRectangleRoi');
    cornerstone.updateImage(element);
  }

  filtersChange = async (e, f, expandeds, selectedFlatRows) => {
    let payload = {
      aiCheckId: this.state.aiCheckId,
      aiInfoId: this.state.aiInfoId,
      searchKeyAndValue: f,
      orderKey: e,
    };
    let analysisResult = [];
    getAnalysisResultLis2t(payload).then(res2 => {
      if (res2.status === 'success') {
        let selectedRowIds = {};
        if (res2.data && res2.data.length > 0) {
          res2.data.map((item, index) => {
            if (selectedFlatRows.indexOf(item.detailId) > -1) {
              selectedRowIds[index] = true;
            }
            let obj = {
              detailId: item.detailId,
              index: index + 1,
              conslusion: item.conslusion,
              location: JSON.parse(item.location),
              _id: guid(),
              selected: item.selected == '1' ? true : false,
              subRows: [],
            };
            let subObj1 = {};
            let subObj2 = {};
            item.result.map((i, index) => {
              if (index < 3) {
                obj['name' + index] = i.value;
              } else if (index < 6) {
                subObj1['name' + (index - 3)] = i.value;
              } else {
                subObj2['name' + (index - 6)] = i.value;
              }
            });
            if (Object.keys(subObj1).length > 0) {
              obj.subRows.push(subObj1);
            }
            if (Object.keys(subObj2).length > 0) {
              obj.subRows.push(subObj2);
            }
            analysisResult.push(obj);
          });
        }
        if (expandeds.length > 0) {
          this.setState({
            ids: selectedRowIds,
            detailIds: expandeds,
            data2: analysisResult,
            subListData: true,
          });
        } else {
          this.setState({
            ids: [],
            detailIds: [],
            checked: false,
            data2: analysisResult,
            subListData: true,
          });
        }
      } else {
        console.log(res2);
      }
    });
  };

  rowSelected = e => {
    this.setState({
      expandeds: { 2: true },
    });
    const studyMetadata = studyMetadataManager.all();
    // const studyMetadata = this.props.studies;
    if (studyMetadata && studyMetadata.length > 0) {
      let index = e.original.location.range_z;
      if (
        studyMetadata[0]._data &&
        studyMetadata[0]._data.displaySets &&
        studyMetadata[0]._data.displaySets.length > 0
      ) {
        let displaySets = studyMetadata[0]._data.displaySets.filter(
          i => i.SeriesInstanceUID == e.original.location.seriesInstanceUid
        );
        if (displaySets && displaySets.length > 0) {
          let displaySet = displaySets[0];
          // let SliceThickness =
          //   displaySet.images[0]._instance.metadata.SliceThickness;
          // let idx = displaySet.numImageFrames - parseInt((index[0] + index[1]) / 2);
          let idx = parseInt((index[0] + index[1]) / 2) - 1;
          let itemData = displaySet.images[idx];

          const toolState = cornerstoneTools.globalImageIdSpecificToolStateManager.saveToolState();
          const imageId = 'dicomweb:' + itemData._data.wadouri;
          if (!toolState[imageId]) {
            toolState[imageId] = {};
          }
          const currentToolState = toolState[imageId]['MarkRectangleRoi'];
          const toolData = currentToolState && currentToolState.data;

          if (toolData && toolData.length) {
            toolData.map(item => {
              item.active = false;
              if (item._id === e.original._id) item.active = true;
            });
            cornerstone.getEnabledElements().forEach(enabledElement => {
              if (enabledElement.image) {
                cornerstone.updateImage(enabledElement.element);
              }
            });
          }

          displaySet.SOPInstanceUID = displaySet.images[idx].SOPInstanceUID;
          this.props.onItemClick(0, displaySet);
        } else {
          const { UINotificationService } = servicesManager.services;

          UINotificationService.show({
            title: '提示',
            message: '数据加载中，请等待数据加载完成后再试',
            type: 'info',
          });
        }
      } else {
        const { UINotificationService } = servicesManager.services;
        UINotificationService.show({
          title: '提示',
          message: '数据加载中，请等待数据加载完成后再试',
          type: 'info',
        });
        // let displaySets = studyMetadata[0].displaySets.filter(i => i.SeriesInstanceUID == e.original.location.seriesInstanceUid);
        // if (displaySets && displaySets.length > 0) {
        //     let displaySet = displaySets[0];
        //     let SliceThickness = displaySet.images[0]._instance.metadata.SliceThickness;
        //     let idx = displaySet.numImageFrames - parseInt((index[0] + index[1]) / SliceThickness / 2);
        //     displaySet.SOPInstanceUID = displaySet.images[idx].SOPInstanceUID;
        //     this.props.onItemClick(0, displaySet);
        // } else {
        //     const { UINotificationService } = servicesManager.services;
        //     UINotificationService.show({
        //         title: '提示',
        //         message:
        //             'seriesInstanceUid错误',
        //         type: 'info',
        //     });
        // }
      }
    }
  };

  remove(val, arr) {
    var index = this.indexOf(val, arr);
    if (index > -1) {
      arr.splice(index, 1);
    }
  }

  indexOf(val, arr) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == val) return i;
    }
    return -1;
  }

  rowValue = async data => {
    this.setState({
      idx: data.index,
      id: data.original.result.id,
      aiCheckId: data.original.result.aiCheckId,
      aiInfoId: data.original.result.aiInfoId,
    });

    let payload = {
      id: data.original.result.id,
      aiCheckId: data.original.result.aiCheckId,
      aiInfoId: data.original.result.aiInfoId,
      status: '20',
      // idx: data.index
    };
    if (data.original.statusLabel == '确认完成') {
      getList({ aiCheckId: this.props.aiCheckId }).then(res2 => {
        if (res2.status === 'success') {
          if (res2.list && res2.list.length > 0) {
            let list = res2.list.map((item, index) => {
              item.index = index + 1;
              item.statusLabel = item.result.status;
              item.resultInfo = item.result.resultInfo;
              return item;
            });
            this.setState({
              data: list,
            });
            this.getAnalysisResultList({
              aiCheckId: payload.aiCheckId,
              aiInfoId: payload.aiInfoId,
            });
          }
        } else {
          console.log(res2);
        }
      });
    } else {
      this.confirmAiResult(payload);
    }
  };

  render() {
    const {
      textareaValue,
      aiCheckId,
      mainListData,
      subListData,
      data,
      idx,
      ids,
      expandeds,
      detailIds,
    } = this.state;
    return (
      <div className="content2">
        <div className="list">
          <div className="main">
            {/* <Tabl2e getRowValue={this.rowValue} columns={this.state.columns} data={this.state.data} ids={this.state.ids}>
                        </Tabl2e> */}
            {mainListData && (
              <MainList getRowValue={this.rowValue} data={data} idx={idx} />
            )}
          </div>
          <div className="sub">
            {/* <AnalysisRepor2t getClickTextareaChange={this.clickTextareaChange} columns={this.state.columns2} data={this.state.data2} checked={this.state.checked} /> */}
            {subListData && (
              <SubList
                getFiltersChange={this.filtersChange}
                getClickTextareaChange={this.clickTextareaChange}
                getRowValue={this.rowSelected}
                columns={this.state.columns2}
                data={this.state.data2}
                orderData={this.state.orderData}
                filters={this.state.filter}
                checked={this.state.checked}
                ids={ids}
                expandeds={detailIds}
                aiInfoId={this.state.aiInfoId}
                aiCheckId={aiCheckId}
              />
            )}
          </div>
        </div>
        <div className="bottom2">
          <div className="report-title2">影像数据描述</div>
          <textarea
            className="report-textarea2"
            value={textareaValue}
            onChange={this.handleTextareaChange}
            onBlur={this.handleBlur}
          />
          <div className="sumbit">
            <button className="btn-sumbit" onClick={this.save}>
              确定
            </button>
          </div>
          {/* <input className="report-textarea2" value={textareaValue} onChange={this.handleTextareaChange} onBlur={this._onBlur} /> */}
        </div>
      </div>
    );
  }
}

export { AnalysisReport };
